<template>
  <div class="second-box">
    <el-form ref="baseFormRef" class="goods-form" :model="baseForm" label-width="128px" :disabled="isReadOnly"
      v-if="baseForm.paramsGroup.length > 0">
      <item-box class="params-info" v-for="(item, index) in baseForm.paramsGroup" :key="index">
        <template v-slot:title>{{ item.groupName }}</template>
        <template v-slot:content>
          <el-form-item v-for="(childItem, childIndex) in item.paramsList" :key="childIndex"
            :label="childItem.paramsName" :prop="'paramsGroup.' + index + '.paramsList.' + childIndex + '.value'"
            :rules="[{ required: childItem.required === '1', message: `请${childItem.paramsType === '1' ? '输入' : '选择'}${childItem.paramsName}`, trigger: childItem.paramsType === '1' ? 'blur' : 'change' }]">
            <el-input v-if="childItem.paramsType === '1'" :placeholder="'请输入' + childItem.paramsName"
              v-model.trim="childItem.value" clearable></el-input>
            <el-select v-if="childItem.paramsType === '2'" v-model="childItem.value"
              :placeholder="'请选择' + childItem.paramsName" clearable>
              <el-option :key="grandChildIndex" v-for="(grandChildItem, grandChildIndex) in childItem.options"
                :label="grandChildItem" :value="grandChildItem"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </item-box>
    </el-form>

    <div v-else class="empty-params flex-c-c">
      <el-result icon="info" title="信息提示" subTitle="该分类暂未配置参数信息，如需添加参数配置，可前往分类管理进行配置。">
        <template slot="extra">
          <p v-hasPermission="['product:category:list']"><el-link type="primary" @click="goToCategory">点击前往分类管理</el-link></p>
          <p><el-link type="primary" @click="getParmas">已分配，点击重新获取参数</el-link></p>
        </template>
      </el-result>
    </div>

    <div class="control-box flex-c-c">
      <el-button type="primary" :disabled="false" plain @click="goPre">上一步</el-button>
      <el-button type="primary" :disabled="false" @click="goNext">下一步</el-button>
    </div>
  </div>
</template>
<script>
import { goodsApi } from "@/api"
export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => { return {} }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      categoryId: "",
      baseForm: {
        paramsGroup: []
      }
    }
  },
  // created() {
  //   此方式 多个页面 时 别的页面也会见听到 会互相影响 有bug
  //   this.$bus.$on("paramsChange", (data) => {
  //     this.categoryId = data.categoryId
  //     this.renderParams(data)
  //   })
  // },
  // beforeDestroy() { this.$bus.$off("paramsChange") },
  methods: {
    goToCategory() {
      this.$router.push({name: "productCategoryManage"})
    },
    // 设置参数
    setParams(data) {
      this.categoryId = data.categoryId
      this.renderParams(data)
    },
    renderParams(data) {
      if (!data.groupJson) {
        this.baseForm.paramsGroup = []
      } else {
        this.baseForm.paramsGroup = JSON.parse(data.groupJson)

        // 如果是查看详情  渲染详情
        if (this.detailInfo.groupJson) {
          const paramsGroup = JSON.parse(this.detailInfo.groupJson)
          let targetList = []
          for (let k = 0; k < paramsGroup.length; k++) {
            targetList = targetList.concat(paramsGroup[k].paramsList)
          }

          for (let i = 0; i < this.baseForm.paramsGroup.length; i++) {
            const item = this.baseForm.paramsGroup[i]
            for (let j = 0; j < item.paramsList.length; j++) {
              const childItem = item.paramsList[j]
              if (targetList.length > 0) {
                const target = targetList.find(targetItem => {
                  return targetItem.paramsName === childItem.paramsName
                })
                if (target) {
                  childItem.value = target.value
                }
              }
            }
          }
        }
      }
    },
    // 根据分类获取参数接口
    getParmas() {
      goodsApi.getParamsByCategoryId({ categoryId: this.categoryId }).then(data => {
        if (!data.groupJson) {
          this.$modal.msgWarning("还未配置参数信息，如需添加参数配置，可前往分类管理进行配置。")
          return
        }
        this.renderParams(data)
      })
    },
    // 上一步
    goPre() {
      this.$emit("pre")
    },
    // 下一步
    goNext() {
      if (this.baseForm.paramsGroup.length === 0) {
        this.$emit("next", { groupJson: "[]" })
        return
      }
      this.$refs.baseFormRef.validate(valid => {
        if (valid) {
          const form = {
            groupJson: JSON.stringify(this.baseForm.paramsGroup)
          }
          this.$emit("next", form)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.second-box {
  .params-info {
    margin-top: 12px;
  }

  .empty-params {
    height: 500px;
    background: #fff;
    margin-top: 12px;
  }

  ::v-deep .goods-form {
    .el-form-item__content {

      .el-cascader,
      .el-select,
      .el-input {
        width: 360px !important;
      }
    }
  }
}
</style>